import { Navigate, useLocation } from "react-router-dom";
import { DASHBOARD_MAP, toV2Route } from "@/constants/routes";

export default function LegacyMapRedirect() {
  const { search, hash } = useLocation();
  return (
    <Navigate
      replace={true}
      to={{ pathname: toV2Route(DASHBOARD_MAP), search, hash }}
    />
  );
}
